import * as Sentry from "@sentry/react";

export function captureErrorMessage (message:string){
      Sentry.captureMessage(message);
  }
  
  export function captureErrorException (exception:unknown){
    Sentry.captureException(exception);  
  }